import * as React from 'react';

function SvgCopyText(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
    >
      <path
        d="M6.85693 0H2.07122C2.03193 0 1.99979 0.0321429 1.99979 0.0714286V0.571429C1.99979 0.610714 2.03193 0.642857 2.07122 0.642857H6.49979V6.78571C6.49979 6.825 6.53193 6.85714 6.57122 6.85714H7.07122C7.11051 6.85714 7.14265 6.825 7.14265 6.78571V0.285714C7.14265 0.127679 7.01497 0 6.85693 0ZM5.71408 1.14286H1.14265C0.984612 1.14286 0.856934 1.27054 0.856934 1.42857V6.16696C0.856934 6.24286 0.887291 6.31518 0.940862 6.36875L2.48818 7.91607C2.50783 7.93571 2.53015 7.95179 2.55426 7.96518V7.98214H2.59176C2.62301 7.99375 2.65604 8 2.68997 8H5.71408C5.87211 8 5.99979 7.87232 5.99979 7.71429V1.42857C5.99979 1.27054 5.87211 1.14286 5.71408 1.14286ZM2.55336 7.07321L1.78461 6.30357H2.55336V7.07321ZM5.35693 7.35714H3.12479V6.08929C3.12479 5.89196 2.96497 5.73214 2.76765 5.73214H1.49979V1.78571H5.35693V7.35714Z"
        fill="#38B2A6"
      />
    </svg>
  );
}

export default SvgCopyText;
